import {
  ChangeDetectionStrategy,
  Component, EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelectionList } from '@angular/material/list';
import { eventsByDay } from 'app/events/helpers/events-by-day';

@Component({
  selector: 'app-event-list-select',
  templateUrl: './event-list-select.component.html',
  styleUrls: ['./event-list-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class EventListSelectComponent implements  OnChanges {

  @Input() events;
  @Input() allowSelectAll = false;
  @Input() loading = false;

  @Input() selectedEventIds = [];

  @Output() selectedEvents: EventEmitter<any[]> = new EventEmitter<any[]>();
  @ViewChild('eventList') eventList: MatSelectionList;

  calendarDays = [];

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.events) {
      this.calendarDays = eventsByDay(this.events, true);
    }
  }

  selectionsChanged() {
    this.selectedEvents.emit(this.eventList.selectedOptions.selected.map(s => s.value));
  }

  selectAllChanged(event: MatCheckboxChange) {
    if (event.checked) {
      this.eventList.selectAll();
      this.selectionsChanged();
    } else {
      this.eventList.deselectAll();
      this.selectionsChanged();
    }
  }
}
